import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { Intake, Patient, StateCodeCheck, MedicalCondition, ConditionDisplay } from '../models/index';
import { Api, ErrorHelper, Session, Ui, Utility } from '../services/index';
import { MyModal } from '../components/modal/modal';
import {TranslateService} from '@ngx-translate/core'; 
 

@Component({
  selector: 'app-exam-reason',
  templateUrl: './exam-reason-for-exam.html',
  styleUrls: ['exam-reason-for-exam.css']
})

export class ExamReasonForExam implements OnInit {
  @ViewChild('modalConditionInformation') public _modalConditionInformation: MyModal;
  @ViewChild('modalnoservice') public _modalnoservice: MyModal;
  @ViewChild('myBHNotice') public _modalBHNotice: MyModal;
  @ViewChild('bhSelect') public _bhSelect: any;
  
  _subscription: any;
  langSelected: string = '';
  complaintList: Array<ConditionDisplay>;
  consentChecked: boolean = false;
  recordReleaseConsent: boolean = false;
  intake: Intake = new Intake;
  localEmail: string;
  localPhone: string;
  medicationHistoryConsentChecked: boolean = false;
  patient: Patient = new Patient;
  patientId: number;
  reasonFormGroup: FormGroup;
  loading:boolean = false;
  untreatableComplaints = ['Ear Infection'];
  stateList: any[];
  public localFields: Object = { text: 'name', value: 'name' };
  public localFieldsEng: Object = { text: 'conditionName_Eng', value: 'conditionName_Eng' };
  public localFieldsEsp: Object = { text: 'conditionName_Esp', value: 'conditionName_Esp' };
  public stateFields: Object = { text: 'name', value: 'abbreviation' };
  public autoreactiveplaceholder: String;
  public autoreactiveStateplaceholder: String;
  public privacyChecked: boolean;
  public termsChecked: boolean
  public financialChecked: boolean;
  public treatmentChecked: boolean;
  public continueClicked: boolean;
  patientFormGroup: FormGroup;
  patientPreferenceGroup: FormGroup;
  isBHService: boolean = false;



  constructor(private api: Api,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private changeDetectorRef: ChangeDetectorRef,
    private errorHelper: ErrorHelper,
    private fb: FormBuilder,
    private router: Router,
    private service: NotificationsService,
    private session: Session,
    private ui: Ui) {
    if (this.session.providerBio) {
      this.session.intakeRequestedProviderId = null;
      this.session.providerBio = null;
    } 
    
    this.patientId = this.route.snapshot.params['patientId'] || '';

    this.intake.userId = this.session.patient.userId;
    this.intake.firstName = this.session.patient.profile.firstName;
    this.intake.lastName = this.session.patient.profile.lastName;
    this.intake.dob = this.session.patient.profile.dateOfBirth;

    // if (this.session.patient.preferences.contactEmail) {
    //   this.localEmail = this.session.patient.preferences.contactEmail;
    // } else {
    //   this.localEmail = this.session.patient.email;
    // }

    // if (this.session.patient.preferences.contactPhoneNumber) {
    //   this.localPhone = this.session.patient.preferences.contactPhoneNumber;
    // } else {
    //   this.localPhone = this.session.patient.phoneNumber;
    // }

    if (this.session.intakeLob === 'UC') {
      this.reasonFormGroup = this.fb.group({
        'chiefComplaint': new FormControl(this.intake.chiefComplaint, Validators.required),
        'reasonForVisit': new FormControl(this.intake.reasonForVisit),
        'email': new FormControl(null, [this.emailOrEmpty, Validators.required]),
        'phoneNumber': new FormControl(
          null,
          Validators.compose([
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(14),
            Validators.pattern(/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i)
          ])),
        'state': new FormControl(this.patient.profile.state, Validators.required),
        'checkedConsent': new FormControl(this.consentChecked, Validators.requiredTrue),
        'recordReleaseConsent': new FormControl(this.recordReleaseConsent)
      });
    } else {
      this.reasonFormGroup = this.fb.group({
        'chiefComplaint': new FormControl(this.intake.chiefComplaint, Validators.required),
        'email': new FormControl(null, [this.emailOrEmpty, Validators.required]),
        'phoneNumber': new FormControl(
          null,
          Validators.compose([
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(14),
            Validators.pattern(/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i)
          ])),
        'state': new FormControl(this.patient.profile.state, Validators.required),
        'checkedConsent': new FormControl(this.consentChecked),
        'recordReleaseConsent': new FormControl(this.recordReleaseConsent)
        // 'checkedMedicationHistoryConsent': new FormControl(this.medicationHistoryConsentChecked, Validators.requiredTrue)
      });
    }
    this._subscription = session.langChange.subscribe((value) => { 
      this.langSelected = value; 
      this.getChiefComplaints();
    });
    
    this.patientPreferenceGroup = this.fb.group({
      'contactEmail': new FormControl(this.patient.preferences.contactEmail, [this.emailOrEmpty]),
      'contactPhoneNumber': new FormControl(
        this.patient.preferences.contactPhoneNumber,
        Validators.compose([
          Validators.minLength(10),
          Validators.maxLength(14),
          Validators.pattern(/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i)
        ]))
    });

    this.patientFormGroup = this.fb.group({
      'emergencyContactName': new FormControl(this.patient.profile.emergencyContactName, Validators.required),
      'emergencyContactRelationship': new FormControl(this.patient.profile.emergencyContactRelationship, Validators.required),
      'emergencyContactPhoneNumber': new FormControl(this.patient.profile.emergencyContactPhone, Validators.required),
    });
  }

  emailOrEmpty(control: AbstractControl): ValidationErrors {
    if (!control.value) {
      return null;
    }

    return Validators.email(control);
  }

  bhStateCheck(control: any) { //I don't think this function is ever actually used
    this.loading = true;
    let stateToCheck = new StateCodeCheck();
    stateToCheck.stateCode = control.value;
    stateToCheck.lineOfBusiness = this.session.intakeLob;

    this.api.checkStateIsValidForService(stateToCheck).subscribe(res => {
      if (res.isValidState) {
        this.reasonFormGroup.controls['state'].setValue(control.statecode);
        this.loading = false;
        return { 'invalidState': false };
      } else {
        this.reasonFormGroup.controls['currentState'].setValue('');
        this.loading = false;
        this._modalnoservice.open();
        return { 'invalidState': true };
      }
    })
  }
  checkStateCheck(stateCode) { //I don't think this function is ever actually used
  this.loading = true;
  let stateToCheck = new StateCodeCheck();
  stateToCheck.stateCode = stateCode;
  stateToCheck.lineOfBusiness = this.session.intakeLob;

  this.api.checkStateIsValidForService(stateToCheck).subscribe(res => {
    if (res.isValidState) {
      this.reasonFormGroup.controls['state'].setValue(stateCode);
      this.loading = false;
      return { 'validState': false };
    } else {
      this.reasonFormGroup.controls['state'].setValue('');
      this.loading = false;
      this._modalnoservice.open();
      return { 'invalidState': true };
    }
  })
}

  onChange(newValue: any) {
  
    if(newValue.type === 'change'){
      console.log(newValue.target.value);
      console.log(this.reasonFormGroup.controls['state'].value)
      this.checkStateCheck(this.reasonFormGroup.controls['state'].value);
    }
    //this.checkStateCheck(newValue);
 
}
  get checkedConsent() { return this.reasonFormGroup.get('checkedConsent'); }
  get chiefComplaint() { return this.reasonFormGroup.get('chiefComplaint'); }
  get email() { return this.reasonFormGroup.get('email'); }
  get reasonForVisit() { return this.reasonFormGroup.get('reasonForVisit'); }
  get phoneNumber() { return this.reasonFormGroup.get('phoneNumber'); }
  get state() { return this.reasonFormGroup.get('state'); }

  get emergencyContactName() { return this.patientFormGroup.get('emergencyContactName'); }
  get emergencyContactRelationship() { return this.patientFormGroup.get('emergencyContactRelationship'); }
  get emergencyContactPhone() { return this.patientFormGroup.get('emergencyContactPhone'); }

  ngOnInit() {
    this.loading = true;
    this.translateService.get('REASON_FOR_EXAM_SELECT_COMPLAINT').subscribe((res: string) => {
      if(res){
        this.autoreactiveplaceholder  = res;
      }else{
        this.autoreactiveplaceholder  = 'Select Complaint';
      }
      
      console.log(res);
    });    
    
    this.translateService.get('REASON_FOR_EXAM_SELECT_STATE').subscribe((res: string) => {
      if(res){
        this.autoreactiveStateplaceholder  = res;
      }else{
        this.autoreactiveStateplaceholder  = 'Current Location';
      }
      
      console.log(res);
    });

    this.api.getConditionsByServiceLine(this.session.intakeLob).subscribe(ccRes => {
      this.complaintList = ccRes;
      this.loading = false;
    },(error) => {
      this.loading = false;
    });
    

    // let complaints = this.api.getSearchMedicalConditionsByLob('', this.session.intakeLob);
    // complaints.subscribe(response => {

    //   //For translation of chief complaints from English to Spanish. 
    //   let translateComplaints = response;
    //   if (this.session.intakeLob === 'UC') {
    //     translateComplaints.forEach(_item => {
    //       let _transSourceTOConvert = 'UC_COMPLAINTS.' + _item.name.toUpperCase().trim();
    //       this.translateService.get(_transSourceTOConvert).subscribe((res: string) => {
    //         if(res){
    //           _item.name = res;
    //         }else{
    //           _item.name = _item.name;
    //         }
            
    //         console.log(res);
    //     });
  
  
    //     })
    //   }else{
    //     translateComplaints.forEach(_item => {
    //       let _transSourceTOConvert = 'BH_COMPLAINTS.' + _item.description.toUpperCase().trim();
    //       this.translateService.get(_transSourceTOConvert).subscribe((res: string) => {
    //         if(res){
    //           _item.name = res;
    //         }else{
    //           _item.name = _item.name;
    //         }
            
    //         console.log(res);
    //     });
  
  
    //     })
    //   }

    //   this.complaintList = translateComplaints;
    //   ///End Translation //

      
    //   if (!this.changeDetectorRef['destroyed']) {
    //     this.changeDetectorRef.detectChanges();
    //   }
    //   this.loading = false;
    // })
    this.stateList = this.session.stateList;
    this.isBHService = this.session.intakeLob === 'BH';

    this.getPatient(this.patientId)
  }
 
  getPatient(patientId) {
    this.loading = true;
    let patient = this.api.getPatientById(patientId);
    patient.subscribe(response => {
      this.patient = response;
      })
    }
  getChiefComplaints(){
    this.api.getConditionsByServiceLine(this.session.intakeLob).subscribe(ccRes => {
      this.complaintList = ccRes;
      this.loading = false;
    },(error) => {
      this.loading = false;
    });
    // let complaints = this.api.getSearchMedicalConditionsByLob('', this.session.intakeLob);
    // complaints.subscribe(response => {
      
    //         //For translation of chief complaints from English to Spanish. 
    //         let translateComplaints = response;
    //         if (this.session.intakeLob === 'UC') {
    //           translateComplaints.forEach(_item => {
    //             let _transSourceTOConvert = 'UC_COMPLAINTS.' + _item.name.toUpperCase().trim();
    //             this.translateService.get(_transSourceTOConvert).subscribe((res: string) => {
    //               if(res){
    //                 _item.name = res;
    //               }else{
    //                 _item.name = _item.name;
    //               }
                  
    //               console.log(res);
    //           });
        
        
    //           })
    //         }else{
    //           translateComplaints.forEach(_item => {
    //             let _transSourceTOConvert = 'BH_COMPLAINTS.' + _item.description.toUpperCase().trim();
    //             this.translateService.get(_transSourceTOConvert).subscribe((res: string) => {
    //               if(res){
    //                 _item.name = res;
    //               }else{
    //                 _item.name = _item.name;
    //               }
                  
    //               console.log(res);
    //           });
        
        
    //           })
    //         }
      
    //         this.complaintList = translateComplaints;
    //         ///End Translation //
      
            
    //         if (!this.changeDetectorRef['destroyed']) {
    //           this.changeDetectorRef.detectChanges();
    //         }
    //         this.loading = false;
    //       })

  }
  getIntakeLOB(){
    return this.session.intakeLob;
  }

  getStateList(){
    return this.session.stateList;
  }

  openInformedConsent() {
    let consentDoc = "https://memd.secure.force.com/agreement/agreements?name=consentphs";
    let newWindow = window.open("about:blank", "_blank");
    newWindow.opener = null;
    newWindow.location.href = consentDoc;
  }

  updateConsent() {
    this.patient.acceptedTerms = this.consentChecked;
  }
  updateConsentRelease(){
    //this.recordReleaseConsent 
  }

  updateMedicationHistoryConsent() {
  }
  checkConditionInformation(){
    this.continueClicked = true;
    if (this.session.intakeLob === 'BH' && (!this.treatmentChecked || !this.termsChecked)) {
      return false;
    }
    if (this.chiefComplaint.value === 'Other'){
      this._modalConditionInformation.open();
    } else if (this.isBHService){
      this._modalBHNotice.open();
    } else {
      this.submitTapped();
    }
  }

  closeConditionInformation(){
    this._modalConditionInformation.close();
  }

  conditionNotSupportedContinue(){
    this._modalConditionInformation.close();
    this.submitTapped();
  }

  closeNoServiceInformation(){
    this._modalnoservice.close();
  }

  submitTapped() {

    this.loading = true;
    if (this.isBHService){
      this._modalBHNotice.close();
    }
    this.requesting(true);
    let stateToCheck = new StateCodeCheck();
    stateToCheck.stateCode = this.state.value;
    stateToCheck.lineOfBusiness = this.session.intakeLob;

    if(this.untreatableComplaints.indexOf(this.chiefComplaint.value) > -1){
      this.service.error('MeMD does not treat ' + this.chiefComplaint.value + 's. Please visit your primary care provider.');
      this.loading = false;
      return;
    }

    this.api.checkStateIsValidForService(stateToCheck).subscribe(res => {
      if (res.isValidState) {
        this.intake.chiefComplaint = this.chiefComplaint.value;
        if (this.session.intakeLob === 'UC') {
          this.intake.reasonForVisit = this.reasonForVisit.value;
        }
        this.intake.contactPhoneNumber = Utility.sanitizePhoneNumber(this.phoneNumber.value);
        this.intake.contactEmail = this.email.value;
        this.intake.currentState = this.state.value;
        this.intake.lineOfBusiness = this.session.intakeLob;
        this.intake.recordReleaseConsent = this.recordReleaseConsent;
        this.intake.TreatmentConsent = this.treatmentChecked ? this.getCurrentDateTime() : null;
        this.intake.PrivacyPracticesConsent = this.privacyChecked ? this.getCurrentDateTime() : null;
        this.intake.FinancialResponsibilityAssignmentConsent = null;
        this.intake.TermsAndConditionsConsent = this.termsChecked ? this.getCurrentDateTime() : null;
        
      let savedata = this.patient;
      savedata.profile.emergencyContactName = this.patientFormGroup.get('emergencyContactName').value;
      savedata.profile.emergencyContactRelationship = this.patientFormGroup.get('emergencyContactRelationship').value;
      savedata.profile.emergencyContactPhone = this.patientFormGroup.get('emergencyContactPhoneNumber').value;
          
        this.api.updatePatientProfile(this.patient.userId,savedata).subscribe(res =>{
        }, ex => {
          this.service.error("there was an issue updating emergency contact into");
        });
        this.api.createIntake(this.intake).subscribe(response => { 
          this.session.clientIntake = this.intake;
          this.session.serverIntake = response;
          this.session.uploadFiles = [];
          this.loading = false;
          if (this.session.intakeLob === 'BH') {
       
            //this.router.navigate(['/exam-select-pharmacy/' + this.patientId]);
            this.router.navigate(['/how-to-schedule/' + this.patientId ]);
          } else {
            this.router.navigate(['/exam-select-pharmacy/' + this.patientId]);
          }
          this.requesting(false);
        }, ex => {
          this.loading = false;
          this.errorHelper.handleServerValidation(this.reasonFormGroup, ex)
          this.requesting(false);
        });
      } else {
        this.service.error('The selected state (' + this.state.value + ') is not supported at this time');
        this.reasonFormGroup.controls['state'].setValue('');
        this.loading = false;
      }
    })

  }

  requesting(requesting: boolean) {
    this.ui.showLoadingIndicator(requesting);
  }

  termsTapped() {
    let caredocurl = "http://memd.force.com/agreement/agreements?name=useagreement";
    let newWindow = window.open("about:blank", "_blank");
    newWindow.opener = null;
    newWindow.location.href = caredocurl;
  }

  getCurrentDateTime() {
    return new Date().toISOString();
  }

  privacyTapped() {
    let caredocurl = "http://memd.force.com/agreement/agreements?name=privacy";
    let newWindow = window.open("about:blank", "_blank");
    newWindow.opener = null;
    newWindow.location.href = caredocurl;
  }

}
